module.exports = __webpack_public_path__ + "media/images/sign-in-with-google-40aa2c4e64eae2d91a235462a0f2b892.svg";